import React, { useState } from 'react';
import { Typography, withStyles } from '@material-ui/core';
import TextField from '@markinson/uicomponents-v2/TextFieldV1';
import SelectField from '@markinson/uicomponents-v2/SelectField';
import Button from '@material-ui/core/Button';
import styles from './VehicleSearch.styles';
import { ArrowBack, Search } from '@markinson/uicomponents-v2/SvgIcons';
import TabbedSearchScreen from '@markinson/uicomponents-v2/TabbedSearchScreen';
import { Column } from 'devextreme-react/data-grid';
import CloseIcon from '@markinson/uicomponents-v2/SvgIcons/Clear';
import { useVRContextSelector, useVSDispatch } from './VehicleSearchContext';
import { VehicleActionTypes } from './VehicleSearch.actions';
import { IAutoISearchVehicleByAttributeRequest, IAutoISearchVehicleResponse, IAutoIVehicleFacade } from 'api/swaggerTypes';
import { encodeHtml, IVehicleSearchProps, MANUAL_TRIAL_MINUS, mapCatalogueTypes, tabbedLookupProps } from './VehicleSearch.properties';
import { useSPContextSelector } from 'components/Worksale/Worksale.context';
import Selectors from 'components/Worksale/Worksale.selectors';

const getSelectValue = (vehicle) => {
  if (vehicle.VehicleId !== 0) return vehicle.VehicleId;
  if (vehicle.SelectValue === 0) return vehicle.SelectText;

  return vehicle.SelectValue;
};

const getManualTrailUpdate = (manualTrail, currentAttr, parsedValue, text, nextVehicleAttribute) => {
  if (currentAttr && parsedValue !== undefined) {
    return [
      ...manualTrail,
      {
        attr: currentAttr,
        value: parsedValue,
        text: currentAttr === 'CatalogueSubtype' ? text : null,
        nextAttr: nextVehicleAttribute,
      },
    ];
  }

  return manualTrail;
};

const getNextCriteria = (manualCriteria, currentAttr, parsedValue, nextVehicleAttribute) => ({
  ...(manualCriteria || {}),
  ...(currentAttr ? { [currentAttr]: encodeHtml(parsedValue) } : {}),
  VehicleAttribute: nextVehicleAttribute || manualCriteria?.VehicleAttribute,
});

const getBaseCriteria = (manualCriteria) => {
  const base = { VehicleAttribute: manualCriteria?.VehicleAttribute };
  Object.keys(base || {}).forEach((k) => {
    if (k !== 'VehicleAttribute') base[k] = null;
  });

  return base;
};

const getRegoDisabled = (payload, selectedCatalogueType, inManualSearch) =>
  !payload.CatalogueType || payload.searchText || !selectedCatalogueType?.isRegoSearchEnabled || inManualSearch;

const getStateDisabled = (payload) => !payload.Rego;

const getSearchTextDisabled = (payload, selectedCatalogueType, inManualSearch) =>
  !payload.CatalogueType || payload.Rego || !selectedCatalogueType?.isSmartSearchEnabled || inManualSearch;

const getSearchBtnDisabled = (payload, inManualSearch) =>
  !payload.CatalogueType || (!(payload.Rego && payload.State) && !payload.searchText) || inManualSearch;

const getManualSelectDisabled = (payload, disableManualSearch, selectedCatalogueType) =>
  !payload.CatalogueType || disableManualSearch || !selectedCatalogueType?.isAttributeSearchEnabled || payload.Rego || payload.searchText;

const getBackManualDisabled = (payload, manualTrail, selectedCatalogueType) =>
  !payload.CatalogueType || manualTrail.length === 0 || !selectedCatalogueType?.isAttributeSearchEnabled || !!payload.Rego || !!payload.searchText;

const VehicleSearch = (props: IVehicleSearchProps) => {
  const { classes, onCatalogueTypeChage, catalogueTypes, getCatalogueTypeStatesList, searchVehicle, manualVehicleSearch, defaultCatalogueTypeId, vehicleMainStyle = {} } = props;
  const [formatedCatalogueTypes, setFormatedCatalogueTypes] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [open, setOpen] = useState(false);
  const [manualVehiclesSelectList, setManualVehiclesSelectList] = useState([]);
  const [manualCriteria, setManualCriteria] = useState(null);
  const [nextVehicleAttribute, setNextVehicleAttribute] = useState(null);
  const [manualSelected, setManualSelected] = useState(null);
  const [manualTrail, setManualTrail] = useState<any>([]);
  const [singleSelection, setSingleSelection] = useState<any>([]);
  const contextDispatch = useVSDispatch();
  const CatalogueTypeId = useVRContextSelector<'CatalogueTypeId'>((state) => state.CatalogueTypeId);
  const Searched = useVRContextSelector<'Searched'>((state) => state.Searched);
  const ManualSelectionRef = React.useRef(null);
  const [autoVehicleSelectionData, setAutoVehicleSelectionData] = useState<any>(null);
  const [disableManualSearch, setDisableManualSearch] = useState<boolean>(false);
  const [inManualSearch, setInManualSearch] = useState<boolean>(false);
  const [manualSearchVehicleList, setManualSearchVehicleList] = useState<any>(null);
  const [vehicleSearchData, setVehicleSearchData] = useState<any>(null);
  const [selectedCatalogueType, setSelectedCatalogueType] = useState<any>(null);

  const [skipManualSelected, setSkipManualSelected] = useState(true);

  const [payload, setPayload] = useState({
    CatalogueType: null,
    Rego: '',
    State: null,
    searchText: '',
  });

  const latestRef = React.useRef<any>(null);

  // keep ref updated every render
  latestRef.current = {
    payload,
    selectedCatalogueType,
    vehicleSearchData,
    manualSearchVehicleList,
    inManualSearch,
    disableManualSearch,
    autoVehicleSelectionData,
    ManualSelectionRef,
    singleSelection,
    formatedCatalogueTypes,
    statesList,
    manualVehiclesSelectList,
    manualCriteria,
    nextVehicleAttribute,
    manualSelected,
    manualTrail,
  };

  const worksaleLookupPanelOpen = useSPContextSelector(Selectors.worksaleLookupPanelOpen);

  React.useEffect(
    () => {
      return () => {
        contextDispatch({
          [VehicleActionTypes.setSearched]: latestRef.current,
        });
      };
    },
    []
  );

  const setters = {
    payload: setPayload,
    inManualSearch: setInManualSearch,
    selectedCatalogueType: setSelectedCatalogueType,
    vehicleSearchData: setVehicleSearchData,
    manualSearchVehicleList: setManualSearchVehicleList,
    disableManualSearch: setDisableManualSearch,
    autoVehicleSelectionData: setAutoVehicleSelectionData,
    singleSelection: setSingleSelection,
    formatedCatalogueTypes: setFormatedCatalogueTypes,
    statesList: setStatesList,
    manualVehiclesSelectList: setManualVehiclesSelectList,
    manualCriteria: setManualCriteria,
    nextVehicleAttribute: setNextVehicleAttribute,
    manualSelected: setManualSelected,
    manualTrail: setManualTrail,
  };

  React.useEffect(
    () => {
      if (!Searched) return;

      Object.entries(setters).forEach(([k, set]) => {
        const val = (Searched as any)[k];
        const hasValue =
          val !== undefined &&
          val !== null &&
          (!Array.isArray(val) || val.length > 0);

        if (hasValue) (set as any)((prev: any) => (Object.is(prev, val) ? prev : val));
      });

      // clear after hydrating
      contextDispatch({ [VehicleActionTypes.setSearched]: null });
    },
    [Searched]
  );

  React.useEffect(
    () => {
      if (catalogueTypes?.length > 0) {
        if (CatalogueTypeId !== -1) {
          setPayload({
            ...payload,
            ['CatalogueType']: CatalogueTypeId
          });

          contextDispatch({
            [VehicleActionTypes.setCatalogueTypeId]: CatalogueTypeId,
          });
        } else if (defaultCatalogueTypeId && defaultCatalogueTypeId !== 0) {
          setPayload({
            ...payload,
            ['CatalogueType']: defaultCatalogueTypeId
          });

          contextDispatch({
            [VehicleActionTypes.setCatalogueTypeId]: defaultCatalogueTypeId,
          });
        }
        setFormatedCatalogueTypes(mapCatalogueTypes(catalogueTypes));

      }
    },
    [catalogueTypes, defaultCatalogueTypeId]);

  React.useEffect(
    () => {
      if (CatalogueTypeId !== -1) {
        onCatalogueTypeChage(CatalogueTypeId);
        getCatalogueTypeStatesList(CatalogueTypeId)
          .then((response) => {
            setStatesList([{ label: 'Select state', value: null, disabled: true }, ...(response ?? [])]);
          });
        setTimeout(
          () => {
            manualVehicleSearch(CatalogueTypeId)
              ?.then((response: IAutoISearchVehicleResponse) => {
                onManualVehicleSearchResponse(response, false);
              });
          },
          0);
      }
    },
    [CatalogueTypeId, catalogueTypes]);

  React.useEffect(
    () => {
      if (CatalogueTypeId !== -1) {
        setSelectedCatalogueType(catalogueTypes?.find((item) => item.catalogueTypeId === CatalogueTypeId) ?? null);
      }
    },
    [CatalogueTypeId, catalogueTypes]);

  React.useEffect(
    () => {
      if (autoVehicleSelectionData !== null) {
        onManualVehicleSelection(autoVehicleSelectionData?.SelectValue, autoVehicleSelectionData?.SelectText);
        setAutoVehicleSelectionData(null);
      }
    },
    [autoVehicleSelectionData]);

  const onSelectChange = (event) => {
    const { name, value } = event.target;
    setPayload({
      ...payload,
      [name]: value
    });
  };

  const getManualVehiclesSelectList = () => manualVehiclesSelectList;

  const onCatalogueTypeChange = (event) => {
    const { name, value } = event.target;
    resetSearchData(true);
    setPayload((prev) => ({
      ...prev,
      [name]: value
    }));

    contextDispatch({
      [VehicleActionTypes.setCatalogueTypeId]: value,
      [VehicleActionTypes.setVehicleId]: -1,
    });
  };

  const onTextChange = (event) => {
    const { name, value } = event.target || {};
    setPayload({
      ...payload,
      [name]: value
    });
  };

  const transformManualVehiclesForSelect = (data) => {
    const { VehicleSearchCriteria } = data;

    return data?.Vehicles?.map((item, index) => {
      const { SelectText } = item;

      return {
        id: index + 1,
        label: SelectText,
        value: getSelectValue(item),
        //isDisplayOnly: SelectText?.includes(VehicleSearchCriteria?.VehicleAttribute),
        disabled: SelectText?.includes(VehicleSearchCriteria?.VehicleAttribute),
      };
    });
  };

  const handleSearchVehicleResponse = (response) => {
    contextDispatch({
      [VehicleActionTypes.setSelectedCatalogueEntry]: null,
    });
    if (response?.Vehicles?.length > 1) {
      setVehicleSearchData(response?.Vehicles);
      setOpen(true);
    }
    if (response?.Vehicles?.length === 1) {
      const { VehicleDescription, VehicleId } = response?.Vehicles[0];
      setManualTrail([]);
      setSingleSelection(VehicleDescription);
      contextDispatch({
        [VehicleActionTypes.setVehicleId]: VehicleId,
      });
    }
  };

  const searchHandler = () => {
    searchVehicle(payload)
      ?.then(handleSearchVehicleResponse);
  };

  const onModuleChange = React.useCallback(
    (moduleId) => {
      console.log(moduleId);
    },
    []);

  const onClose = (data) => {
    if (data) {
      const vehicleId = data?.VehicleId;
      const Vehicle = data?.VehicleDescription;
      contextDispatch({
        [VehicleActionTypes.setVehicleId]: vehicleId,
      });
      setSingleSelection(Vehicle);
      if (manualSearchVehicleList?.length > 1) {
        onManualVehicleSelection(vehicleId, Vehicle);
      }
    }
    setOpen(false);
  };

  const getManualVehiclesAPIHandler = async (searchCriteria: any): Promise<IAutoISearchVehicleResponse> => {
    const response = await manualVehicleSearch(CatalogueTypeId, searchCriteria);
    const vehicles = response?.Vehicles;
    const searchParams = response?.VehicleSearchCriteria;
    if (response !== null && vehicles.length === 0) {
      const nextCriteria = {
        ...(searchParams || {}),
        ...(searchParams?.VehicleAttribute ? { [searchParams.VehicleAttribute]: '' } : {}),
        VehicleAttribute: response?.NextVehicleAttribute ?? null,
      };

      return getManualVehiclesAPIHandler(nextCriteria);
    }

    return response;
  };

  const handleManualSelectionFinal = (value, text) => {
    contextDispatch({
      [VehicleActionTypes.setVehicleId]: value,
    });
    setManualVehiclesSelectList([
      {
        label: text,
        value: value,
        disabled: true,
        selected: true,
      },
    ]);
    setManualTrail([]);
    setSingleSelection(text);
    setNextVehicleAttribute('');
    setManualSelected(value);
    setDisableManualSearch(true);
  };

  const handleManualSelectionNavigate = async (parsedValue, text, currentAttr) => {
    setManualSelected(parsedValue);
    setSingleSelection(null);
    setManualTrail((prevTrail) => getManualTrailUpdate(prevTrail, currentAttr, parsedValue, text, nextVehicleAttribute));
    const nextCriteria = getNextCriteria(manualCriteria, currentAttr, parsedValue, nextVehicleAttribute);
    const nextResponse = await getManualVehiclesAPIHandler(nextCriteria);
    onManualVehicleSearchResponse(nextResponse);
  };

  const onManualVehicleSelection = async (value: any, text: any): Promise<void> => {
    try {
      setInManualSearch(true);
      if (!nextVehicleAttribute) {
        handleManualSelectionFinal(value, text);

        return;
      }
      const parsedValue =
        isNaN(Number(value)) ? value?.replace(/\s+/g, ' ').trim() : Number(value);
      const currentAttr = manualCriteria?.VehicleAttribute;
      await handleManualSelectionNavigate(parsedValue, text, currentAttr);
    } catch (error) {
      console.error('Error in onManualVehicleSelection:', error);
    }
  };

  const handleManualVehicleSearchResponseSingle = (singleVehicle) => {
    const selectValue = getSelectValue(singleVehicle);
    setManualVehiclesSelectList([
      {
        label: singleVehicle.SelectText,
        value: selectValue,
        disabled: true,
        selected: true,
      },
    ]);
    setAutoVehicleSelectionData({
      SelectValue: selectValue,
      SelectText: singleVehicle.SelectText,
    });
  };

  const handleManualVehicleSearchResponseMultiple = (vehicleCriteria: IAutoISearchVehicleByAttributeRequest, vehicles: IAutoIVehicleFacade[], showPicker: boolean) => {
    const selectLabel = vehicleCriteria?.VehicleAttribute === 'CatalogueSubtype' ? 'Select Type' : `Select ${vehicleCriteria?.VehicleAttribute ?? ''}`;
    const transformedVehicles = transformManualVehiclesForSelect({ Vehicles: vehicles, VehicleSearchCriteria: vehicleCriteria }) ?? [];
    setManualVehiclesSelectList(null);
    setManualVehiclesSelectList([
      { label: selectLabel, value: null, disabled: true },
      ...transformedVehicles,
    ]);
    if (vehicleCriteria?.VehicleAttribute !== 'Details' && showPicker) {
      ManualSelectionRef?.current?.showPicker();
    } else if (vehicleCriteria?.VehicleAttribute === 'Details') {
      const processedVehicles = vehicles.map((vehicle) => {
        return {
          ...vehicle,
          VehicleLongDescription: vehicle.VehicleLongDescription && vehicle.VehicleLongDescription !== '' ? vehicle.VehicleLongDescription : vehicle.SelectText,
          VehicleDescription: vehicle.VehicleDescription && vehicle.VehicleDescription !== '' ? vehicle.VehicleDescription : vehicle.SelectText,
        };
      });
      setManualSearchVehicleList(processedVehicles);
      setOpen(true);
    }
  };

  const onManualVehicleSearchResponse = (
    response: IAutoISearchVehicleResponse,
    showPicker: boolean = true
  ) => {
    if (!response) return;
    const vehicleCriteria = response.VehicleSearchCriteria ?? null;
    const nextAttribute = response.NextVehicleAttribute ?? null;
    const vehicles = response.Vehicles ?? [];
    setManualCriteria(vehicleCriteria);
    setNextVehicleAttribute(nextAttribute);
    setManualSelected(null);
    if (vehicles.length === 1) {
      handleManualVehicleSearchResponseSingle(vehicles[0]);
    } else if (vehicles.length > 1) {
      handleManualVehicleSearchResponseMultiple(vehicleCriteria, vehicles, showPicker);
    }
  };

  const onBreadcrumbClick = async (idx) => {
    const selectedUpTo = manualTrail.slice(0, idx + 1);
    const clicked = selectedUpTo[idx];
    if (!clicked) return;
    const base = getBaseCriteria(manualCriteria);
    selectedUpTo.forEach(({ attr, value }) => {
      base[attr] = value;
    });
    base.VehicleAttribute = clicked.nextAttr || clicked.attr;
    const response = await getManualVehiclesAPIHandler(base);
    onManualVehicleSearchResponse(response);
    setManualTrail(selectedUpTo);
  };

  const resetSearchData = (forceClear = false) => {
    resetSimpleSearch();
    resetManualSearch(forceClear);
  };

  const resetSimpleSearch = () => {
    setSingleSelection('');
    setPayload({
      ...payload,
      Rego: '',
      State: null,
      searchText: '',
    });
    contextDispatch({
      [VehicleActionTypes.setVehicleId]: -1,
    });
    setVehicleSearchData(null);
  };

  const resetManualSearch = async (forceClear = false) => {
    if (skipManualSelected && !forceClear) {
      setSkipManualSelected(false);

      return;
    }
    setInManualSearch(false);
    setDisableManualSearch(false);
    contextDispatch({
      [VehicleActionTypes.setVehicleId]: -1,
    });
    setSingleSelection('');
    setManualTrail([]);
    setManualSearchVehicleList(null);
    const response = await manualVehicleSearch(CatalogueTypeId);
    onManualVehicleSearchResponse(response, false);
  };

  const stepBackManual = async () => {
    if (manualTrail.length === 0) {
      await resetManualSearch();

      return;
    }
    const idx = manualTrail.length - MANUAL_TRIAL_MINUS;
    if (idx >= 0) {
      await onBreadcrumbClick(idx);
    } else {
      await resetManualSearch();
    }
  };

  // Helper: Render vehicle breadcrumb or single selection
  const renderSelectedVehicle = () => {
    if (singleSelection) {

      return <span>{singleSelection}</span>;
    }

    return manualTrail.map(({ attr, value, text }, idx) => (
      <span key={`${attr}-${idx}`} style={{ display: 'inline-flex', alignItems: 'center' }}>
        <span
          onClick={() => onBreadcrumbClick(idx)}
          title={`Go to ${attr}`}
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          {text || value}
        </span>
        {idx < manualTrail.length - 1 && (
          <Typography
            component='span'
            style={{ margin: '0 4px', fontSize: 16, verticalAlign: 'middle' }}
          >
            &gt;
          </Typography>
        )}
      </span>
    ));
  };

  // Helper: Manual search controls
  const renderManualControls = () => (
    <div className={classes.manualContainer}>
      <SelectField
        innerRef={(ref) => ManualSelectionRef.current = ref}
        options={getManualVehiclesSelectList()}
        name={'manualVehicle'}
        value={manualSelected}
        onChange={(event) => onManualVehicleSelection(event?.target?.value, event?.currentTarget?.innerText)}
        width={worksaleLookupPanelOpen ? '280px' : '400px'}
        disabled={manualSelectDisabled}
      />
      <Button
        variant='contained'
        onClick={stepBackManual}
        disabled={backManualDisabled}
        className={classes.backBtn}
      >
        <ArrowBack /> Back
      </Button>
    </div>
  );

  // Helper: Tabbed search screen
  const renderTabbedSearchScreen = () => (
    open && (
      <TabbedSearchScreen
        {...tabbedLookupProps}
        open={open}
        dataGridKey='VehicleId'
        defaultSearchText=''
        hideLookupSearchOption={false}
        onModuleChange={onModuleChange}
        onClose={onClose}
        callSearchLookupOnOpen={false}
        onSearch={() => setOpen(false)}
        hideSearchBar={true}
        data={manualTrail.length === 0 ? vehicleSearchData : manualSearchVehicleList}
      >
        <Column dataField='VehicleLongDescription' caption='Vehicle' />
      </TabbedSearchScreen>
    )
  );

  // Extracted disabling logic for clarity

  const regoDisabled = getRegoDisabled(payload, selectedCatalogueType, inManualSearch);
  const stateDisabled = getStateDisabled(payload);
  const searchTextDisabled = getSearchTextDisabled(payload, selectedCatalogueType, inManualSearch);
  const searchBtnDisabled = getSearchBtnDisabled(payload, inManualSearch);
  const manualSelectDisabled = getManualSelectDisabled(payload, disableManualSearch, selectedCatalogueType);
  const backManualDisabled = getBackManualDisabled(payload, manualTrail, selectedCatalogueType);

  return (
    <div className={classes.mainCnt} style={{ ...vehicleMainStyle }}>
      <div className={classes.rowContainer}>
        <div className={classes.firstRow}>
          <SelectField
            options={formatedCatalogueTypes}
            name={'CatalogueType'}
            value={payload.CatalogueType}
            onChange={onCatalogueTypeChange}
            size='medium'
          />
          <div className={classes.selectedVehicle}>
            <Typography className={classes.selectedVehicleLabel}>
              SELECTED VEHICLE:
            </Typography>
            <div className={classes.selectedVehicleValue}>{renderSelectedVehicle()}</div>
          </div>
        </div>
        <Button
          variant='text'
          onClick={() => {
            resetSearchData(true);
            setPayload((prev) => ({
              ...prev,
              CatalogueType: defaultCatalogueTypeId
            }));
            manualVehicleSearch(defaultCatalogueTypeId)
              ?.then((response: IAutoISearchVehicleResponse) => {
                onManualVehicleSearchResponse(response, false);
              });
          }}
          className={classes.clearBtn}
        >
          <CloseIcon /> Clear
        </Button>
      </div>
      <div className={classes.secondRow}>
        <div className={classes.firstSelection}>
          <TextField
            placeholder='Enter rego plate'
            value={payload.Rego}
            name='Rego'
            disabled={regoDisabled}
            onChange={onTextChange}
            sx={{ minWidth: '230px' }}
          />
          <SelectField
            options={statesList}
            name={'State'}
            value={payload.State}
            onChange={onSelectChange}
            size='small'
            disabled={stateDisabled}
          />
          <TextField
            placeholder='Enter VIN or text to search'
            value={payload.searchText}
            name='searchText'
            disabled={searchTextDisabled}
            onChange={onTextChange}
            autoComplete={'off'}
            sx={{ minWidth: '230px' }}
          />
          <Button
            variant={'contained'}
            className={classes.search}
            color='secondary'
            disabled={searchBtnDisabled}
            onClick={searchHandler}
          >
            <Search />
            Search
          </Button>
        </div>
        {renderManualControls()}
        {renderTabbedSearchScreen()}
      </div>
    </div>
  );
};

export default withStyles(styles, { index: 1 })(VehicleSearch);
